import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import history from '../../Store/history';
import ContentManagementReducer from './ContentManageReducer';
import DashBoardReducer from './DashboardReducer';
import DreammanageReducer from './DreammanageReducer';
import EducationReducer from './EducationReducer';
import EthnicityReducer from './EthnicityReducer';
import HobbiesReducer from './HobbiesReducer';
import InterstedReducer from './InterstedReducer';
import MySelfReducer from './MySelfReducer';
import ProfileReducer from './ProfileReducer';
import RelationReducer from './RelationReducer';
import ReligionReducer from './ReligionReducer';
import SignInReducer from './SignInReducer';
import toggleSubnavReducer from './ToggleSubnavReducer';
import UserManagementReducer from './UsermanageReducer';

const persistConfig = {
  key: 'config',
  storage,
};

const rootReducer = combineReducers({
  SignInReducer,
  DashBoardReducer,
  UserManagementReducer,
  ContentManagementReducer,
  DreammanageReducer,
  RelationReducer,
  InterstedReducer,
  ProfileReducer,
  toggleSubnavReducer,
  HobbiesReducer,
  MySelfReducer,
  EducationReducer,
  EthnicityReducer,
  ReligionReducer,
  router: connectRouter(history),
});
export default persistReducer(persistConfig, rootReducer);
